<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Anagrafica</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="name"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import departmentForm from '@/services/departments/department.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      name: undefined,
      loadingDepartment: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(departmentForm.department)

    var self = this
    departmentForm.on('update', function(data) {
      self.handleObjectChanges(data.department)
    })
  },
  methods: {
    fields() {
      return ['name']
    },
    handleObjectChanges(department) {
      const fields = this.fields()
      const newValKeys = Object.keys(department)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && department[field] != this[field]) {
          this[field] = department[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      departmentForm.setValid(newVal)
    },
    name(newVal) {
      departmentForm.updateField('name', newVal)
    },
  }
};
</script>